export default __webpack_public_path__ + "static/media/coin_dot.c0631fda.svg";